import React, { FunctionComponent, useState } from "react";

import { Org, User } from "src/lib/graphql/types";

import { useUser } from "src/hooks/useUser";
import ProfileData from "./ProfileData";
import { useRouter } from "next/router";

type ProfileMainProps = {
  entity: Org | User;
};

const ProfileMain: FunctionComponent<ProfileMainProps> = ({ entity }) => {
  return (
    <div className="index-profile-main-content container">
      <ProfileData
        entity={entity}
      />
    </div>
  );
};

export default ProfileMain;
